import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    emitCrosstimeAt: Array,
    hashedId: String
  }

  initialize() {
    // window_wq is how we can queue video data to be loaded by Wistia's library.
    // This is documented here:
    // https://wistia.com/support/developers/player-api#use-window-_wq-to-get-a-video-handle
    window._wq = window._wq || []
    this.setupVideo()
  }

  setupVideo() {
    _wq.push({
      id: this.hashedIdValue,
      onReady: (video) => {
        this.convertWistiaEventsToDomEvents(video)
        this.addTurnstileAlert(video)
        this.element.wistiaVideo = video
        this.element.dispatchEvent(new CustomEvent(`wistia-video:ready`, { detail: { video: video }, bubbles: true }))
      }
    })
  }

  convertWistiaEventsToDomEvents(video) {
    // Note: "betweentimes" and "crosstime" are not converted, because they require
    // additional arguments.
    // To set crosstime, use emitCrosstimeAt.
    // An alternative to betweentimes is not currently configured because we don't use it, but if
    // you need it, you should be able to copy the pattern set up by emitCrosstimeAt
    const events = [
      "beforeremove", "beforereplace", "cancelfullscreen", "captionschange", "conversion",
      "end", "enterfullscreen", "heightchange", "lookchange", "mutechange", "pause",
      "percentwatchedchanged", "play", "playbackratechange", "secondchange", "seek",
      "silentplaybackmodechange", "timechange", "volumechange", "widthchange"
    ]

    events.forEach((event) => {
      video.bind(event, (...args) => {
        this.element.dispatchEvent(new CustomEvent(`wistia:${event}`, { detail: args, bubbles: true }))
      })
    })

    if (this.emitCrosstimeAtValue) {
      video.bind("crosstime", this.emitCrosstimeAtValue, (...args) => {
        this.element.dispatchEvent(new CustomEvent(`wistia:crosstime:${this.emitCrosstimeAtValue}`, { detail: args, bubbles: true }))
      })
    }
  }

  addTurnstileAlert(video) {
    video.bind("conversion", (..._args) => {
      const error = {
        message: `Video ${video.data.media.hashedId} has Turnstile ON`,
        data: {
          url: window.location.href,
          video: {
            id: video.data.media.hashedId,
            name: video.data.media.name,
            description: video.data.media.seoDescription
          }
        }
      }

      if (window.Rollbar !== undefined) {
        window.Rollbar.error("Turnstile is active for video.", error)
      }
    })
  }

  // this is a UX improvement and not related to the CLE check
  // to prevent different _tabs_ from playing videos.
  pauseOtherVideos() {
    const allVideos = Wistia.api.all()

    for (let i = 0; i < allVideos.length; i++) {
      if (allVideos[i].hashedId() !== this.element.wistiaVideo.hashedId()) {
        allVideos[i].pause()
      }
    }
  }
}
